const footerAsset = name =>
  require(`../../homepage/底部图标及效果图(1)/bottom/${name}`)

const detailAsset = name =>
  require(`../../homepage/detail/${name}`)

export const DETAIL_FEE_NOTE =
  '价格含手续费：平台服务费、转让费、公证费'

export const DETAIL_TRUST_ITEMS = [
  {
    label: '即买即用',
    icon: detailAsset('trust-ready-use.png')
  },
  {
    label: '交易公证',
    icon: detailAsset('trust-notary.png')
  },
  {
    label: '担保交易',
    icon: detailAsset('trust-guarantee.png')
  },
  {
    label: '过户放款',
    icon: detailAsset('trust-transfer.png')
  }
]

export const DETAIL_TRUST_BADGE = detailAsset('trust-office-badge.png')

export const DETAIL_TRUST_NOTE =
  '国家商标局备案机构，交易安全有保障'

export const DETAIL_CONSULTANT_FALLBACK = {
  title: '商标顾问',
  name: '在线客服',
  phone: '',
  qrImage: footerAsset('ewm.jpg'),
  qrHint: '微信扫码邀请顾问协助'
}

export const DETAIL_RECOMMEND_LIMIT = 5

export const DETAIL_EXTRA_TABS = [
  { id: 'info', label: '商标信息' },
  { id: 'guarantee', label: '交易保障' },
  { id: 'transfer', label: '过户资料' },
  { id: 'process', label: '商标流程' }
]

export const DETAIL_GUARANTEE_ITEMS = [
  {
    icon: detailAsset('guarantee-platform.png'),
    title: '平台验标 司法公证',
    desc: '平台6重商标真伪核验，保障商标真实可靠无权益纠纷'
  },
  {
    icon: detailAsset('guarantee-adviser.png'),
    title: '专属顾问 全程包办',
    desc: '平台一对一专属顾问，挑选到转让过户，全程包办'
  },
  {
    icon: detailAsset('guarantee-privacy.png'),
    title: '用户隐私 绝密保护',
    desc: '平台承诺用户隐私信息绝对保密，绝不外泄'
  },
  {
    icon: detailAsset('guarantee-consign.png'),
    title: '商标闲置 免费寄售',
    desc: '平台购买的商标闲置，平台提供免费寄售服务'
  }
]

export const DETAIL_TRANSFER_CERTS = [
  {
    icon: detailAsset('transfer-cert-register.png'),
    label: '商标注册证书',
    note: '（现成）'
  },
  {
    icon: detailAsset('transfer-cert-authorize.png'),
    label: '独家授权书',
    note: ''
  },
  {
    icon: detailAsset('transfer-cert-notary.png'),
    label: '商标公证书',
    note: '（1-3天）'
  },
  {
    icon: detailAsset('transfer-cert-complete.png'),
    label: '转让完成证明',
    note: '（大概3-4个月）'
  }
]

export const DETAIL_PROCESS_STEPS = [
  {
    icon: detailAsset('process-order.png'),
    title: '下单支付',
    desc: '国家商标局备案机构，办理转让手续前可随时退款'
  },
  {
    icon: detailAsset('process-notary.png'),
    title: '商标公证',
    desc: '持有人提供商标授权书，平台协助双方办理转让公证书'
  },
  {
    icon: detailAsset('process-balance.png'),
    title: '支付尾款',
    desc: '公证书下发后，3个工作日内支付尾款，准备转让材料'
  },
  {
    icon: detailAsset('process-transfer.png'),
    title: '办理转让',
    desc: '提交过户资料，3-4个月内商标局审查完毕，下发转让证明'
  }
]

export const DETAIL_TRANSFER_BUYER_IMAGE = detailAsset('transfer-buyer-docs.jpg')
